import { FC, memo } from 'react';

import { IconBase, IconBaseProps, matchSize } from './IconBase';

const IconChevronRightSmall: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} viewBox="0 0 25 25">
      <path
        d="M9.5 19L15.5 13L9.5 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </IconBase>
  );
});

const IconChevronRightMedium: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} viewBox="0 0 65 65">
      <path
        d="M24.5 49.8333L40.5 33.8333L24.5 17.8333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </IconBase>
  );
});

const IconChevronRightBig: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} viewBox="0 0 129 129">
      <path
        d="M48.5 99.1667L80.5 67.1667L48.5 35.1668"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </IconBase>
  );
});

export const IconChevronRight: FC<IconBaseProps> = memo(props => {
  const { size } = props;
  const Icon = matchSize(size, {
    s: IconChevronRightSmall,
    l: IconChevronRightBig,
    otherwise: IconChevronRightMedium,
  });

  return <Icon {...props} />;
});
